
import { useEffect, useRef, useState } from "react";
// import {FaCog, } from "react-icons/fa";
// import adminimg from "../../utils/images/admin_img.png";
// import leftlogo from "../../utils/images/left_logo.png";
import dashboardlogo from "../../utils/images/dashboard-logo.svg";
import { FiClock } from "react-icons/fi";
// import { useLocation } from "react-router";
import {
    ChevronLeft,
    ChevronRight,
    Printer,
    Settings,
    ChevronDown,
    // Pointer,
} from "lucide-react";
// import { FaPen, FaClock } from 'react-icons/fa';
import ManageAccessicon from "../../utils/images/Manage-Access-icon.svg";
import IvyAiicon from "../../utils/images/Ivy-Ai-icon.svg";
import MicrosoftTeamicon from "../../utils/images/Microsoft-icon.svg";
import TimesFeesicon from "../../utils/images/time-icon.svg";
import esignatureicon from "../../utils/images/eSignature-icon.svg";
import { useNavigate } from 'react-router-dom';
import { FaUsers } from 'react-icons/fa';
import wordIcon from '../../../src/utils/images/wordIcon.png';
import pdfIcon from '../../../src/utils/images/pdfIcon.svg';
import mailIcon from '../../../src/utils/images/mailIcon.svg';
import imgIcon from '../../../src/utils/images/imgIcon.svg';
import excelIcon from '../../../src/utils/images/excel-Icon.png';
import { FiSearch } from 'react-icons/fi';
import { BsThreeDotsVertical } from 'react-icons/bs';
// import { MdMemory } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { status } from "../../_constants/commonIVY";
import { correspondanceAction } from "../../_actions";
import { useParams } from "react-router-dom";
import Sidebar from "../../component/Sidebar";
import { config } from "../../config";
// import { matterAction } from '../../_actions';
import Modal from 'react-bootstrap/Modal';
import adminImage from "../../utils/images/admin_img.png";
import updateicon from "../../utils/images/update-icon.svg";
import filtericon2 from "../../utils/images/filter_icon2.svg";

function MatterDetails() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState('');
    const [showModal, setShow] = useState(false);
    const correspondanceData = useSelector((state) => state.correspondence);
    const [errors, setErrors] = useState("")
    // const correspondences = Array.isArray(correspondanceData?.get_correspondence_data) ? correspondanceData.get_correspondence_data : [];
    const [correspondences, setCorrespondences] = useState([]);
    const [isRunning, setIsRunning] = useState(false);
    const [elapsedSeconds, setElapsedSeconds] = useState(0);
    const intervalRef = useRef(null);
    const [isDropDown, setIsDropDown] = useState(false);
    const [activeTab, setActiveTab] = useState("Calendar & Tasks");
    const [activeIndex, setActiveIndex] = useState(null);
    const handleShow = () => setShow(true);
    const [correspondanceToDelete, setCorrespondanceToDelete] = useState(null);
    const [showDelete, setShowDelete] = useState(false);
    const handleCloseDelete = () => setShowDelete(false);
    const { id } = useParams();
    const [createCorrespondance, setCreateCorrespondance] = useState({
        name: "",
        document: ""
    });

    useEffect(() => {
        if (correspondanceData && correspondanceData.get_correspondence_status === status.SUCCESS) {
            setCorrespondences(Array.isArray(correspondanceData.get_correspondence_data) ? correspondanceData.get_correspondence_data : []);
        }
        console.log(63, correspondanceData.get_correspondence_data);

    }, [correspondanceData]);


    useEffect(() => {
        if (id) {
            dispatch(correspondanceAction.getCorrespondance(id));
        }
    }, [dispatch, id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        const formData = new FormData();
        formData.append("matterId", id);
        formData.append("name", createCorrespondance.name);
        formData.append("document", createCorrespondance.document);

        try {
            await dispatch(correspondanceAction.createCorrespondance(formData));
            setTimeout(async () => {
                dispatch(correspondanceAction.getCorrespondance(id));
                handleCloseModal()
            }, 500);


            setCreateCorrespondance({
                name: "", document: ""
            });
        } catch (error) {
            console.error("Error creating correspondence:", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCreateCorrespondance(prev => ({
            ...prev,
            [name]: value
        }));
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: "" }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        if (!createCorrespondance.name) {
            newErrors.name = "Name is required";
        }
        if (!createCorrespondance.document) {
            newErrors.document = "Document file is required";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleCloseModal = () => {
        setShow(false);
        setCreateCorrespondance({
            name: "",
            document: null
        });
        setErrors({});
    };


    const filteredCorrespondences = correspondences.filter(correspondence => {
        if (!search) return true;
        const searchTerm = search.toLowerCase();
        return (
            correspondence.name.toLowerCase().includes(searchTerm)
        );
    });



    useEffect(() => {
        if (isRunning) {
            intervalRef.current = setInterval(() => {
                setElapsedSeconds(prev => prev + 1);
            }, 1000);
        } else {
            clearInterval(intervalRef.current);
        }
        return () => clearInterval(intervalRef.current);
    }, [isRunning]);

    function formatTime(totalSeconds) {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        return [hours, minutes, seconds]
            .map(unit => String(unit).padStart(2, '0'))
            .join(':');
    }

    const handleClick = () => {
        setIsRunning(!isRunning);
    };

    const handleFileChange = (e) => {
        setCreateCorrespondance(prev => ({
            ...prev,
            document: e.target.files[0]
        }));
        if (errors.document) {
            setErrors(prev => ({ ...prev, document: null }));
        }
    };

    const handleShowButton = (index) => {
        setActiveIndex(prev => prev === index ? null : index);
    };

    const handleShowDelete = (id) => {
        setShowDelete(true);
        setActiveIndex(false)
        setCorrespondanceToDelete(id);
    };


    const handleDelete = async () => {
        if (!correspondanceToDelete) return;

        try {
            await dispatch(correspondanceAction.deleteCorrespondance(correspondanceToDelete));
            await dispatch(correspondanceAction.getCorrespondance(id));

            handleCloseDelete();
            setCorrespondanceToDelete(null);
        } catch (error) {
            console.error("Error deleting correspondence:", error);
        }
    };

    


    return (
        <div className="main-wrapper-dashboard">
            <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
            <div className="right-dashboard">
                <div
                    className={`dashboard-screen matter-details ${isOpen ? "main-content-width" : "main-content-small-width"
                        }`}
                >
                    <div className="dashboard-header">
                        <div className="dashboard-search">
                            <div className="dashboard-logo">
                                {!isOpen && (
                                    <img src={dashboardlogo} alt='' className="show-img" onClick={() => navigate(`/dashboard`)} />
                                )}
                                {/* <img
                                    src={dashboardlogo}
                                    alt=""
                                    className={`${isOpen ? "hide-img" : "show-img"}`}
                                /> */}
                            </div>
                            <span className="text-search">
                                NA/1408, Hasan Ali, Road Traffic Accident,Milton Keynes
                            </span>
                        </div>
                        <div className="dashboard-button">
                            <button className="primary-btn-timer" onClick={handleClick}>
                                <FiClock />  {formatTime(elapsedSeconds)}
                            </button>
                        </div>
                    </div>
                    <div className="dashboard-header-bottom">
                        <div className="dashboard-content shadow">
                            <div className="left-icon">
                                <ChevronLeft className="w-5 h-5 cursor-pointer" onClick={() => navigate(`/dashboard`)} />
                                <span
                                    className={`font-bold cursor-pointer ${activeTab == "Calendar" ? "text-white underline" : ""
                                        }`}
                                    onClick={() => setActiveTab("Details & Correspondence")}
                                >
                                    Details & Correspondence
                                </span>
                                <span
                                    className={`font-bold cursor-pointer ${activeTab === "Calendar" ? "text-white underline" : ""
                                        }`}
                                    onClick={() => setActiveTab("Calendar & Tasks")}
                                >
                                    Calendar & Tasks
                                </span>
                                <span
                                    className={`font-bold cursor-pointer ${activeTab === "Calendar" ? "text-white underline" : ""
                                        }`}
                                    onClick={() => setActiveTab("Financial Summary")}
                                >
                                    Financial Summary
                                </span>
                                <span
                                    className={`font-bold cursor-pointer ${activeTab === "Calendar" ? "text-white underline" : ""
                                        }`}
                                    onClick={() => setActiveTab("Times & Fees")}
                                >
                                    Times & Fees
                                </span>
                                {/* <div className="more-icon cursor-pointer">
                                    More <ChevronDown className="w-4 h-4 ml-1" />
                                </div> */}
                                <div
                                    className="relative inline-block more-icon cursor-pointer"

                                >
                                    <div
                                        className="more-icon-cursor-pointer"
                                        onClick={() => setIsDropDown(!isDropDown)}
                                    >
                                        More <ChevronDown className="w-4 h-4 ml-1" />
                                    </div>
                                    <div className={`dropdown ${isDropDown ? 'open' : 'top-smooth'}`}>
                                        {isDropDown && (
                                            <div className="dropdown-content">
                                                <div className="top">
                                                    <h4>Office Accounting</h4>
                                                    <ul className="text-sm text-gray-700 space-y-1">
                                                        <li>Payments & Ledgers</li>
                                                        <li>Credit Ledger</li>
                                                        <li>Anticipated Payments</li>
                                                        <li>Cost Recoveries</li>
                                                    </ul>
                                                </div>
                                                <hr className="line" />
                                                <div className="bottom">
                                                    <h4>Client Funds</h4>
                                                    <ul className="text-sm text-gray-700 space-y-1">
                                                        <li onClick={() => navigate(`/client-address`)}>Client Accounts</li>
                                                        <li>Protected Client Funds</li>
                                                        <li>Separate Designated Client Accounts</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="right-icon">
                                <Printer className="w-5 h-5 cursor-pointer" />
                                <Settings className="w-5 h-5 cursor-pointer" />
                                <ChevronRight className="w-5 h-5 cursor-pointer" />
                            </div>
                        </div>
                    </div>
                    <div className="dashboard-details-content">
                        <div className="first-section">
                            <div className="first-left">
                                <h2>Details</h2>
                            </div>
                            <div className="sidebar-cases">
                                <div className="didebar-content shadow-sm">
                                    <div className="heading-tittle">
                                        <h4>NA/1408</h4>
                                        <p>Road Traffic Accident</p>
                                    </div>
                                    <div className="right-side">
                                        <button className="primary-btn">
                                            TRIAL
                                        </button>
                                        <BsThreeDotsVertical />
                                    </div>
                                </div>
                                <div className="didebar-content shadow-sm">
                                    <div className="heading-tittle">
                                        <h4>NA/1408</h4>
                                        <p>Road Traffic Accident</p>
                                    </div>
                                    <div className="right-side">
                                        <button className="primary-btn">
                                            Limited period expired
                                        </button>
                                        <BsThreeDotsVertical />
                                    </div>
                                </div>
                                <div className="didebar-content shadow-sm">
                                    <div className="heading-tittle">
                                        <h4>NA/1408</h4>
                                        <p>Road Traffic Accident</p>
                                    </div>
                                    <div className="right-side">
                                        <button className="primary-btn">
                                            TRIAL
                                        </button>
                                        <BsThreeDotsVertical />
                                    </div>
                                </div>
                                <div className="didebar-content shadow-sm nth-child">
                                    <div className="didebarnt-content">
                                        <div className="heading-tittle">
                                            <h4>NA/1408</h4>
                                            <p>Road Traffic Accident</p>
                                        </div>
                                        <div className="right-side">
                                            <button className="primary-btn">
                                                TRIAL
                                            </button>
                                            <BsThreeDotsVertical />
                                        </div>
                                    </div>
                                    <div className="extra-text">
                                        <div className="defendant-details">
                                            <h5>Defendant Details</h5>
                                            <BsThreeDotsVertical />
                                        </div>
                                        <div className="defendant-details">
                                            <div className="title_head">
                                                <h5>Defendant Solicitor</h5>
                                                <h6>ABC (Tranding Name)</h6>
                                            </div>
                                            <BsThreeDotsVertical />
                                        </div>
                                    </div>
                                </div>
                                <div className="didebar-content shadow-sm">
                                    <div className="heading-tittle">
                                        <h4>NA/1408</h4>
                                        <p>Road Traffic Accident</p>
                                    </div>
                                    <div className="right-side">
                                        <button className="primary-btn">
                                            in progress
                                        </button>
                                        <BsThreeDotsVertical />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="second-section">
                            <div className="second-left overflow-y-auto scrollable-container max-h-96 scrollbar-thin scrollbar-thumb-cyan-700 scrollbar-track-gray-100">
                                <div className="first-title">
                                    <h2 className="text-lg font-semibold">Correspondence</h2>
                                    <div
                                        onClick={() => window.location.reload()}
                                        className="refresh"
                                    >
                                        <img src={updateicon} alt="" style={{ cursor: 'pointer' }} />
                                    </div>
                                </div>
                                <div className="search-bar">
                                    <FiSearch className='search-icon' />
                                    <input
                                        type="text"
                                        placeholder="Search correspondence"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        className="form-control"
                                    />
                                    <button className="filter-btn">
                                        <img src={filtericon2} alt='' size={9} /> Filter <ChevronDown size={14} />
                                    </button>
                                </div>

                                <div className="">
                                    <table className="w-full">
                                        <div className="table-header">
                                            <div className="left-part">
                                                <input type="checkbox" className="form-checkbox" />
                                                <span className="text-sm text-gray-500 font-medium">Type</span>
                                                <span className="text-sm text-gray-500 font-medium">Item</span>
                                            </div>
                                            <div className="right-part">
                                                <span className="text-sm text-gray-500 font-medium">Staff</span>
                                                <span className="text-sm text-gray-500 font-medium">Created</span>
                                                <Settings className="w-4 h-4" />
                                            </div>
                                        </div>
                                        <tbody className="table-body">
                                            {filteredCorrespondences.length > 0 ? (
                                                filteredCorrespondences.map((item, index) => {
                                                    const ext = item.document.split('.').pop().toLowerCase();

                                                    const getFileIcon = () => {
                                                        if (['doc', 'docx'].includes(ext)) return wordIcon;
                                                        if (['pdf'].includes(ext)) return pdfIcon;
                                                        if (['xls', 'xlsx'].includes(ext)) return excelIcon;
                                                        if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'].includes(ext)) return imgIcon;
                                                        return mailIcon;
                                                    };

                                                    const fileUrl =
                                                        `${config.localApiUrl}/${item.document.replace(/\\/g, '/')}`

                                                    return (
                                                        <tr key={index} className="table-divider">
                                                            <td style={{ display: 'flex', alignItems: 'center' }}>
                                                                <input type="checkbox" className="form-checkbox" />

                                                                <img src={getFileIcon()} alt="file-icon" className="mx-4 w-6 h-6" />
                                                                <span
                                                                    className="text-blue-500 underline cursor-pointer"
                                                                    onClick={() => {
                                                                        if (fileUrl) {
                                                                            const ext = item.document.split('.').pop().toLowerCase();
                                                                            const isOffice = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(ext);

                                                                            // const openUrl = isOffice
                                                                            //     ? `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`
                                                                            //     : fileUrl;

                                                                            // window.open(openUrl);
                                                                        }
                                                                    }}
                                                                >
                                                                    {item.name && item.name.charAt(0).toUpperCase() + item.name.slice(1).toLowerCase()}
                                                                </span>
                                                            </td>

                                                            <td>
                                                                <div className="flex items-center justify-end gap-2">
                                                                    <div className="relative">
                                                                        <img
                                                                            src={adminImage}
                                                                            alt=""
                                                                            className="small-img"
                                                                        />

                                                                    </div>
                                                                    <span className="text-sm text-gray-500 font-medium">
                                                                        {new Date(item.createdAt).toLocaleString('en-GB', {
                                                                            day: '2-digit',
                                                                            month: '2-digit',
                                                                            year: 'numeric',
                                                                        })}
                                                                        {/* {item.createdAt?.split(',')[0] || "18/12/2024"} */}
                                                                    </span>
                                                                    <BsThreeDotsVertical
                                                                        style={{ cursor: "pointer" }}
                                                                        size={15}
                                                                        onClick={() => handleShowButton(index)}
                                                                    />
                                                                    {activeIndex === index && (
                                                                        <div className="delete-action">
                                                                            <button className="btn delete-btn" onClick={() => handleShowDelete(item._id)}>
                                                                                <div className="delete-icon"></div>
                                                                            </button>
                                                                        </div>
                                                                    )}


                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })

                                            ) : (

                                                <tbody>
                                                    <tr>
                                                        <td colSpan="2" className="text-center py-4">
                                                            No documents found
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="third-section">
                            <div className="action-sidebar overflow-y-auto scrollable-container max-h-96 scrollbar-thin scrollbar-thumb-cyan-700 scrollbar-track-gray-100">
                                <h2 className="action-title">Action</h2>
                                <div>
                                    <div className="action-item">
                                        <div className="action-label">
                                            <img src={ManageAccessicon} alt="" className="icon" />
                                            <span className="action-text">Manage Access</span>
                                        </div>
                                        <button className="primary-btn" onClick={handleShow}>
                                            <FaUsers className="icon" size={18} style={{ marginRight: '8px' }} />New Document</button>
                                        <button
                                            className="primary-btn"
                                            onClick={() =>
                                                navigate(`/document-preview/${id}`, {
                                                    state: { data: filteredCorrespondences },
                                                })
                                            }
                                        >
                                            <FaUsers className="icon" size={18} style={{ marginRight: '8px' }} />
                                            View All Document
                                        </button>
                                    </div>
                                    <div className="action-item">
                                        <div className="action-label">
                                            <img src={esignatureicon} alt="" className="icon" />
                                            <span className="action-text">eSignature</span>
                                        </div>
                                    </div>
                                    <div className="action-item action-active">
                                        <div className="action-label">
                                            <img src={TimesFeesicon} alt="" className="icon" />
                                            <span className="action-text">Times & Fees</span>
                                        </div>
                                        <p>New Time Entry</p>
                                    </div>
                                    <div className="action-item">
                                        <div className="action-label">
                                            <span className="action-text">New Fee</span>
                                        </div>
                                    </div>
                                    <div className="action-item action-active">
                                        <div className="action-label">
                                            <img src={MicrosoftTeamicon} alt="" className="icon" size={20} />
                                            <span className="action-text">Microsoft Team Integration</span>
                                        </div>
                                        <p>Open Team</p>
                                    </div>
                                    <div className="action-item">
                                        <div className="action-label">
                                            <span className="action-text">Call</span>
                                        </div>
                                    </div>
                                    <div className="action-item action-active">
                                        <div className="action-label">
                                            <img src={IvyAiicon} alt="" className="icon" size={20} />
                                            <span className="action-text">Ivy Ai</span>
                                        </div>
                                        <p>Matter Ai Chat</p>
                                    </div>
                                    <div className="action-item">
                                        <div className="action-label">
                                            <span className="action-text">Research Ai Law</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={showModal} onHide={handleCloseModal} className="custom-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Create New Correspondence</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group mb-3">
                            <label className="form-label">Name</label>
                            <input
                                type="text"
                                name="name"
                                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                value={createCorrespondance.name}
                                onChange={handleChange}
                                placeholder="Enter name"
                            />
                            {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                        </div>

                        <div className="form-group mb-3">
                            <label className="form-label">Document</label>
                            <input
                                type="file"
                                name="document"
                                className={`form-control ${errors.document ? 'is-invalid' : ''}`}
                                onChange={handleFileChange}
                            />
                            {errors.document && <div className="invalid-feedback">{errors.document}</div>}
                        </div>

                        <div className="d-flex justify-content-end gap-2 mt-4">
                            <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>Cancel</button>
                            <button type="submit" className="btn btn-primary">Save</button>
                        </div>
                    </form>
                </Modal.Body>


            </Modal>

            <Modal show={showDelete} onHide={handleCloseDelete} className="delete-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Confirmtion</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete the  <strong>document</strong>?</Modal.Body>
                <Modal.Footer>
                    <button type="button" className="primary-btn" onClick={handleCloseDelete}>Cancel</button>
                    <button type="button" className="primary-btn secondary-btn" onClick={handleDelete}>Delete</button>
                    {/* <button type="button" className="primary-btn" onClick={handleCloseDelete}>
                        Cancel
                    </button>
                    <button type="button" className="primary-btn secondary-btn" onClick={() => handleDelete(correspondanceToDelete)}>
                        Delete</button> */}
                </Modal.Footer>

                {/* <Modal.Footer>
                    <button variant="secondary" className="primary-btn" onClick={handleCloseDelete}>
                        Cancel
                    </button>
                    <button variant="primary" className="primary-btn secondary-btn" onClick={() => handleDelete(correspondanceToDelete)}>
                        Delete
                    </button>
                </Modal.Footer> */}
            </Modal>


        </div>
    );
}


export default MatterDetails;